import { createEntityAdapter, EntityAdapter, Update } from "@ngrx/entity";
import { ActionReducer, createReducer, on } from "@ngrx/store";
import { Inverter } from "@design/models/inverter.model";
import { InverterState, QuoteInverterState } from "./inverter.state";
import { fromInverterActions } from "./inverter.action";


export const adapter: EntityAdapter<Inverter> = createEntityAdapter<Inverter>();
const inverterInitialState: QuoteInverterState = adapter.getInitialState();
const initialState: InverterState = {
  inverters: inverterInitialState,
  dcAcRatio: 1.2,
  efficiency: 96,
  addedCapacity: 0
}

export const invertersState = (state: InverterState) => state.inverters;

export const inveterReducer: ActionReducer<InverterState> = createReducer(
  initialState,
  on(fromInverterActions.AddInverter, (state,data) =>{
    return {...state, inverters: adapter.upsertOne(data.inverter, state.inverters)};
  }),

  on(fromInverterActions.AddInverters, (state,data) =>{
    return {...state, inverters: adapter.setAll(data.inverters, state.inverters)};
  }),

  on(fromInverterActions.DeleteInverter, (state,data) =>{
    return {...state, inverters: adapter.removeOne(data.inverterId, state.inverters)};
  }),

  on(fromInverterActions.UpdateDcAcRatio, (state,data) =>{
    return {...state, dcAcRatio: data.dcAcRatio};
  }),
  on(fromInverterActions.SetDcAcRatio, (state,data) =>{
    return {...state, dcAcRatio: data.dcAcRatio};
  }),

  on(fromInverterActions.UpdateEfficiency, (state,data) =>{
    return {...state, efficiency: data.efficiency};
  }),
  on(fromInverterActions.SetEfficiency, (state,data) =>{
    return {...state, efficiency: data.efficiency};
  }),

  on(fromInverterActions.UpdateAddedCapacity, (state,data) =>{
    return {...state, addedCapacity: data.addedCapacity};
  }),
  // on(fromInverterActions.UpdateInverter, (state, { inverter }) => {
  //   console.log('UpdateInverter reducer called with:', inverter);
  //   console.log('Current state:', state.inverters);
  //   return {...state, inverters: adapter.updateOne(inverter, state.inverters)};
  // })

  on(fromInverterActions.UpdateInverter, (state, { inverter }) => {
    return { ...state, inverters: adapter.setOne(inverter, state.inverters) };
  })
)
